import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

const PHONE_E164_REGEX = /^\+[1-9]\d{6,14}$/

const languageLevelValues = ['none', 'basic', 'intermediate', 'proficient'] as const
const licenceLevelValues = ['none', 'apulA', 'apulB', 'apulC', 'apulD'] as const

const languageSchema = Yup.string()
  .oneOf([...languageLevelValues])
  .default('none')
const licenceSchema = Yup.string()
  .oneOf([...licenceLevelValues])
  .default('none')

export const useSchema = () => {
  const { t } = useTranslation()

  return Yup.object().shape({
    name: Yup.string().required().max(255),
    phone: Yup.string()
      .optional()
      .default('')
      .test('phone', t('general.validation.invalidPhone'), (value) => !value || PHONE_E164_REGEX.test(value)),
    email: Yup.string().email().optional().default(''),
    languages: Yup.object().shape({
      cz: languageSchema,
      en: languageSchema,
      de: languageSchema,
      pl: languageSchema,
    }),
    licences: Yup.object().shape({
      ski: licenceSchema,
      snowboard: licenceSchema,
    }),
    salaryPrivate: Yup.number().required().min(0).default(0),
    salaryGroup: Yup.number().required().min(0).default(0),
    isActive: Yup.boolean().default(true),
  })
}

export type InstructorFormValues = Yup.InferType<ReturnType<typeof useSchema>>
